module.exports = __webpack_public_path__ + "static/media/16e-03_Chapas3-2016-41x29cm-lápiz-portaminas-HB-sobre-papel-70gr.e4d284b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16e/16e-03_Chapas3-2016-41x29cm-lápiz-portaminas-HB-sobre-papel-70gr.png
// module id = 202
// module chunks = 0